import * as ACTION_TYPES from './types';


const initialState = {
  status: {
    loading: -1,
  },
  data: [],
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.SEARCH_MEDICAL_HISTORY_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loading: 0,
        },
      };
    case ACTION_TYPES.SEARCH_MEDICAL_HISTORY_SUCCEED:
      return {
        data: payload.data,
        status: {
          ...state.status,
          loading: 1,
        },
      };
    case ACTION_TYPES.SEARCH_MEDICAL_HISTORY_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loading: 2,
        },
      };
    default:
      return state;
  }
}
